import React, { forwardRef, useImperativeHandle, useState } from 'react';
import s from '../../styles/AdminDocumentMap.module.css';

export interface AddRowProps {
  onAdd: (name: string) => Promise<void>;
}

export interface AddSubcategoryRowHandle {
  open: () => void;
}

const AddSubcategoryRow = forwardRef<AddSubcategoryRowHandle, AddRowProps>(({ onAdd }, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState('');
  const [saving, setSaving] = useState(false);

  useImperativeHandle(ref, () => ({ open: () => setIsOpen(true) }));

  const close = () => { setValue(''); setIsOpen(false); };

  const submit = async () => {
    const trimmed = value.trim();
    if (!trimmed) return;
    setSaving(true);
    await onAdd(trimmed);
    setSaving(false);
    close();
  };

  if (!isOpen) return null;

  return (
    <div className={s.modalOverlay} onClick={close}>
      <div className={s.modal} onClick={e => e.stopPropagation()}>
        <p className={s.modalTitle}>Add Subcategory</p>

        <div className={s.modalField}>
          <label className={s.modalLabel}>Subcategory Name</label>
          <input
            className={s.modalInput}
            placeholder="Enter subcategory name..."
            value={value}
            onChange={e => setValue(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') submit(); if (e.key === 'Escape') close(); }}
            autoFocus
          />
        </div>

        <div className={s.modalActions}>
          <button className={`${s.btnSm} ${s.btnSecondary}`} onClick={close}>Cancel</button>
          <button className={`${s.btnSm} ${s.btnPrimary}`} onClick={submit} disabled={saving || !value.trim()}>
            {saving ? '…' : 'Add Subcategory'}
          </button>
        </div>
      </div>
    </div>
  );
});

AddSubcategoryRow.displayName = 'AddSubcategoryRow';
export default AddSubcategoryRow;
